
import { ref } from '@vue/composition-api'
import store from '@/store'
import { ReportService } from '@/app/reports/share/report.service'

export default function reportForm() {

  const owners = ref([])

  const contracts=ref([]);
  const contracts_orig=ref([])
  const plans=ref([])

  const planfilterdata = ref({
    type:"plan",
    planType:'containerPest',
    cols:"id,name",
    user: store.state.auth.userData.id
  });
  
  ReportService.getCategoriesFilterBy({
    type: 'plan',
    planType:'containerPest'
  }).then(response => { 
    owners.value = response.data.owners
    contracts.value = response.data.contracts
    contracts_orig.value=JSON.parse(JSON.stringify(response.data.contracts))
  
  })
 
  const reFilterPlans=(name,data)=>{
    if(name=="owners"){
      planfilterdata.value.owner=data.owners;
     }else if(name=="contracts"){
      planfilterdata.value.contract=data.contracts;
     }
    ReportService.getPlanOptions(
      planfilterdata.value   
     ).then(response =>{   plans.value = response.data})
  }

  ReportService.getPlanOptions({
    type: "plan",
    planType: 'containerPest',
    cols: "id,name",
    user: store.state.auth.userData.id
  }).then(response => { plans.value = response.data })

  return {  
    owners,
    contracts,
    contracts_orig,
    plans,
    reFilterPlans
  }
}
